
import React from 'react';
import { PaymentsContainer2 } from "./common";
import { sprintf } from "sprintf-js";
import {Info} from "../../funcs/utils";
import {DEVICE_WIDTH} from "../../../lib/constants";
import {PershingMailInstructions} from "../../funcs/pershing";
import {SchwabMailInstructions} from "../../funcs/schwab";

const MailDepositBody = props => {

  const component = props.component;
  const acct_index = parseInt(component.props.acct_index, 10);
  const acct_key = sprintf("%04d", acct_index);
  const tda = component.props.tda[acct_key];
  const account_number = tda ? tda.tda_account_number : "ACCT_NUMBER";
  const div_style = {
    padding: "0.5rem 0",
  }

  if (!tda) {
    return null;
  }
  const mail = tda.custodian === "PERSHING"
    ? (<PershingMailInstructions account_number={account_number}/>)
    : (<SchwabMailInstructions account_number={account_number}/>)

  return (
    <div>
      <div style={div_style}>
        <p>If you would prefer to mail in your funds:</p>
      </div>
      { mail }
    </div>
  )

};

const MailDeposit = props => {
  const component = props.component;
  const info_text = "Below are the mailing addresses to send a physical check to fund your account.  Either thru regular or overnight mail (slightly safer).";
  const device = {
    width: component.props.app.width,
  }
  const do_medium = component.props.app.width < DEVICE_WIDTH.medium;

  const info = (
    <Info
      id={"mail_deposit"}
      text={info_text}
      popup_style={{ width: "30rem" }}
      style={{fontSize: do_medium ? "1rem" : "1.5rem"}}
      component={component}/>);

  return (
    <PaymentsContainer2
      device={device}
      title={"Mail Deposit"}
      suffix={info}
      client={component.props.client}>
      <MailDepositBody
        component={component}/>
    </PaymentsContainer2>
  )
}

export { MailDeposit, MailDepositBody };
